import React from "react"

const PlayIco = () => {
  return (
    <svg
      id="Calque_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 65 45"
      width="65"
      height="45"
    >
      <rect
        class="cls-1"
        fill="var(--primary)"
        x="2.16"
        y="2.28"
        width="60.28"
        height="40.61"
        rx="8.5"
        ry="8.5"
      />
      <polyline
        class="cls-2"
        fill="#232322"
        points="25.72 11.06 45.72 22.66 25.89 34.19 25.89 11.07"
      />
    </svg>
  )
}

export { PlayIco }
